import { DeleteSystemRequestSchema, DeleteSystemResponseSchema } from './delete-system.schema';
/**
 * Delete System Endpoint Contract
 * Deletes a system by ID
 */ export const deleteSystemContract = {
    method: 'DELETE',
    path: '/api/v2/system/:id',
    description: 'Delete a system by ID',
    requestSchema: DeleteSystemRequestSchema,
    responseSchema: DeleteSystemResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'System not found'
        }
    }
};

//# sourceMappingURL=delete-system.contract.js.map